declare global {
  // eslint-disable-next-line
  interface Window {
    Weblog: any;
  }
}
const buffer: any = {
  collect: [],
  sendImmediately: [],
  updateCommonPackage: [],
  pluginsRadarEvent: [],
};

let fmpTime = 0;
let whiteScreenTime = 0;
let firstScreenTime = 0;

let log = {
  collect: (...args: any[]) => {
    buffer.collect.push(args);
  },
  sendImmediately: (...args: any[]) => {
    buffer.sendImmediately.push(args);
  },
  fmp: (customTime) => {
    
    if (customTime) {
      fmpTime = customTime;
      console.log('fmp: ', customTime);
    } else {
      fmpTime = Date.now();
      console.log('fmp: ', fmpTime);
    }
  },
  whiteScreen: () => {
    whiteScreenTime = Date.now();
  },
  firstScreen: () => {
    firstScreenTime = Date.now();
  },
  updateCommonPackage: (...args: any[]) => {
    buffer.updateCommonPackage.push(args);
  },
  plugins: {
    radar: {
      event: (...args: any) => {
        buffer.pluginsRadarEvent.push(args);
      },
    },
  },
};

//按需加载
const _loadScript = function (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.async = true;
    script.type = 'text/javascript';
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    script.setAttribute('crossorigin', 'anonymous');
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

window._loadScript = _loadScript;

setTimeout(async () => {
  const weblogPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/log.hybrid.js');
  const radarPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/radar.js');
  const autoPVPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/autopv.js');

  await weblogPromise;
  await radarPromise;
  await autoPVPromise;

  const cookies = window.comUtils?.utils?.getCookies();

  let weblogConfig = {
    user_id: cookies['ud'] || '',
    version_name: cookies['appver'] || '',
    channel: cookies['c'] || '',
    network_type: (cookies['net'] as any) || 'unknown',
    product_name: 'ESHOP_WEB',
    // h5_extra_attr: {
    //     // release: process.env.VUE_APP_RELEASE_VERSION,
    //     realm: 'activity',
    //     // subRealm: 'double12',
    //     // projectName: 'kwaishop-pub-activity',
    //     origin_url: location.href,
    // },
  };
  const weblog = new Weblog(
    {
      // 开启后，自定义事件双报
      enableV3CustomEvent: true,
      // 桥接自定义事件业务标识
      // biz: 'ESHOP_WEB',
      env: 'production',
      plugins: [
        new Radar({
          projectId: '648a1b197c', // 雷达平台上的唯一标识
          sampling: 1, // 上报采样率，1 为全部上报
          APIHook(apiData) {
            const { request, response, duration } = apiData;
            let data = {};
            try {
              data = JSON.parse(response?.data);
            } catch (e) {}
            return {
              response_code: data?.result,
              response_msg: data?.error_msg || data?.message || data?.msg || '网络异常',
              status: response.status,
            };
          },
        }),
        new AutoPV(),
      ],
      //   referer: {
      //     value: search.showType || '',
      //     type: search.pageType || 'native',
      //   },
      attachUrl: true,
      urlMap: {},
    },
    weblogConfig,
  );
  window.__weblog__ = weblog;
  let collectItem: any = null;
  let immediateItem: any = null;
  let commonPackageItem: any = null;
  let radarEvent: any = null;
  while ((immediateItem = buffer.sendImmediately.shift())) {
    // @ts-ignore
    weblog.sendImmediately(...immediateItem);
  }
  while ((collectItem = buffer.collect.shift())) {
    // @ts-ignore
    weblog.collect(...collectItem);
  }
  while ((commonPackageItem = buffer.updateCommonPackage.shift())) {
    // @ts-ignore
    weblog.updateCommonPackage(...commonPackageItem);
  }
  while ((radarEvent = buffer.pluginsRadarEvent.shift())) {
    // @ts-ignore
    weblog.plugins.radar.event(...radarEvent);
  }

  // 采样上报时不上报页面性能
  if (fmpTime) {
    weblog.plugins.radar.fmp(fmpTime);
  }

  if (whiteScreenTime) {
    weblog.plugins.timingMonitor.mark('whiteScreen', {
      endPoint: whiteScreenTime,
    });
  }

  if (firstScreenTime) {
    weblog.plugins.timingMonitor.mark('firstScreen', {
      endPoint: firstScreenTime,
    });
  }

  log.collect = (...args) => {
    try {
      // @ts-ignore
      weblog.collect(...args);
    } catch (error) {
      // do nothing
    }
  };
  log.sendImmediately = (...args) => {
    try {
      // @ts-ignore
      weblog.sendImmediately(...args);
    } catch (err) {
      console.log(`sendImmediately error: ${err}`);
    }
  };
  log.updateCommonPackage = (...args) => {
    try {
      // @ts-ignore
      weblog.updateCommonPackage(...args);
    } catch (err) {
      console.log(`updateCommonPackage error: ${err}`);
    }
  };
  log.fmp = () => {
    weblog.plugins.radar.fmp();
  };
  log.whiteScreen = () => {
    weblog.plugins.timingMonitor.mark('whiteScreen');
  };
  log.firstScreen = () => {
    weblog.plugins.timingMonitor.mark('firstScreen');
  };
  log.plugins.radar.event = (...args) => {
    weblog.plugins.radar.event(...args);
  };
}, 500);

export default log;
